/** One processed scan of a looked-up VIN. */
export interface VinLookupResult {
  timestamp: string;
  status: string;
  vinCode: string;
  decodedMake: string;
  decodedModel: string;
  decodedYear: number;
  processorSite: string;
  userName: string;
  emailID: string;
  scanHistoryId: string;
  /** Not guaranteed — absent for scans without a certificate. */
  certificateLink: string | null;
}

/** What a lookup found, and which of the searched values matched nothing. */
export interface VinLookupData {
  results: VinLookupResult[];
  notFoundVins: string[];
  notFoundPartialVins: string[];
}

/** A lookup with nothing in it: the page's state before results land, and the fallback for an empty response. */
export const EMPTY_VIN_LOOKUP: VinLookupData = { results: [], notFoundVins: [], notFoundPartialVins: [] };

export interface VinLookupResponse {
  success: boolean;
  message: string;
  code: string;
  data: VinLookupData;
  timestamp: string;
}

/** One certificate to email, as the endpoint identifies it. */
export interface CertificateRequest {
  vinCode: string;
  scanHistoryId: string;
}

export interface CertificateEmailResponse {
  success: boolean;
  /** Written for the user — shown as-is in the snackbar. */
  message: string;
  code: string;
  /** The job producing the email. Nothing reads it yet. */
  data: { jobId: string } | null;
  timestamp: string;
}
